var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.title,"destroy-on-close":true,"append-to-body":"","visible":_vm.visible,"width":"70%"},on:{"update:visible":function($event){_vm.visible=$event}}},[(_vm.visible)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }